import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

export const HeaderTitle = () => {
  const navigate = useNavigate();

  const handleTitleClick = () => {
    sessionStorage.setItem('userRequestedHome', 'true');
    navigate("/");
  };

  return (
    <div className="flex flex-col items-start cursor-pointer" onClick={handleTitleClick}>
      <motion.h1 
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.2, duration: 0.5 }}
        className="text-3xl font-bold font-arabic text-primary"
      >
        دراية - <span className="font-sans">Diraya.AI</span>
      </motion.h1>
      <motion.p
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.3, duration: 0.5 }}
        className="text-sm text-muted-foreground mt-1 font-arabic"
      >
        الدليل الشامل لأدوات الذكاء الاصطناعي
      </motion.p>
    </div>
  );
};